export default __webpack_public_path__ + "static/media/forwardIcon.d2b40824.svg";